import { loadStripe } from "@stripe/stripe-js";

import isProduction from "../../utils/isProduction";

// Stripe public key
export const stripePublicKey = isProduction() ? "pk_live_aWEqwJx5cs3Ii9wjtGqfHRzD" : "pk_test_iDIOXDFWbtkJPAHzV0PSnON0";
export const stripePromise = loadStripe(stripePublicKey);
